import React from "react";
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";
import { Icomponent } from "../../../core/components/basegame/interface/Icomponent";


interface IframeworkBuyFeature {
    data: {
        COMPONENTS: Icomponent[]
    }

}

export const frameworkBuyFeature: IframeworkBuyFeature = {

    data: {
        "COMPONENTS": [
            {
                "id": "BuyFeatureMainContainer",
                "name": "BuyFeatureMainContainer",
                "type": "Container",
                "x": 0,
                "y": 0,
                "visible": false,
                "filterTypes": [],
                child: [

                    {
                        "name": "BuyFeature_Graphic",
                        "type": "Graphic",
                        "shape": "rectangle",
                        "visible": false,
                        "alpha": 0.8,
                        "color": "0x000000",
                        "x": 0,
                        "y": 0,
                        "width": 1920,
                        "height": 1080,

                    },
                    {
                        "name": "BuyFeature_Graphic_Portrait",
                        "type": "Graphic",
                        "shape": "rectangle",
                        "visible": false,
                        "alpha": 0.8,
                        "color": "0x000000",
                        "x": 0,
                        "y": 0,
                        "width": 1080,
                        "height": 1920,

                    },

                    {
                        "id": "rightBuyContainer",
                        "name": "rightBuyContainer",
                        "type": "Container",
                        "x": 580,
                        "y": 230,
                        "visible": false,
                        "filterTypes": [],
                        child: [
                            {
                                "name": "buy_bonus_base_right",
                                "image": "buy_bonus_base.png",
                                "type": objectTypes.Sprite,
                                "layout": false,
                                "uimode": "desktop",
                                "visible": true,
                                "width": 515,
                                "height": 714,
                                "x": 0,
                                "y": 0,
                            },
                            {
                                "id": "buyBtn_right",
                                "name": "buyBtn_right",
                                "type": objectTypes.Sprite,
                                "buttonMode": true,
                                //"uimode": "desktop",
                                "interactive": false,
                                "layout": true,
                                "x": 250,
                                "y": 575,
                                "width": 180,
                                "height": 93,
                                "text": "BuyBtnText",
                
                                "textStyle": {
                                    fontFamily: 'impact',
                                    fontSize: 30,
                                    fontStyle: 'bold',
                                    fill: ['#fd9d08', '#f0e700'],
                                    align:'center'
                                },
                                "anchor": [0.5, 0.5],
                                "visible": true,
                                "buttonState": {
                                    up: 'buy_up.png',
                                    out: 'buy_up.png',
                                    down: 'buy_down.png',
                                    disable: 'buy_disable.png',
                                    enable: 'buy_up.png',
                                    hover: 'buy_over.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "arrowBtn_back",
                                "name": "arrowBtn_back",
                                "type": objectTypes.Sprite,
                                "buttonMode": true,
                                //"uimode": "desktop",
                                "interactive": false,
                                "layout": true,
                                "x": 75,
                                "y": 390,
                                "width": 27,
                                "height": 54,
                                "anchor": [0.5, 0.5],
                                "visible": true,
                                "buttonState": {
                                    up: 'back_btn.png',
                                    out: 'back_btn.png',
                                    down: 'back_btn.png',
                                    disable: 'back_btn.png',
                                    enable: 'back_btn.png',
                                    hover: 'back_btn.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "arrowBtn_next",
                                "name": "arrowBtn_next",
                                "type": objectTypes.Sprite,
                                "buttonMode": true,
                                //"uimode": "desktop",
                                "interactive": false,
                                "layout": true,
                                "x": 415,
                                "y": 390,
                                "width": 27,
                                "height": 54,
                                "anchor": [0.5, 0.5],
                                "visible": true,
                                "buttonState": {
                                    up: 'next_btn.png',
                                    out: 'next_btn.png',
                                    down: 'next_btn.png',
                                    disable: 'next_btn.png',
                                    enable: 'next_btn.png',
                                    hover: 'next_btn.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "right_15_text",
                                "name": "right_15_text",
                                "type": "Text",
                                "x": 245,
                                "y": 226,
                                "width": 800,
                                "visible": true,
                                "text": "buyInNumber1",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'Oswald-SemiBold',
                                    fontSize: 40,
                                    fontStyle: 'bold',
                                    fill: ['#a47f00', '#fdf972'],
                                    align: 'center',
                                    wordWrap: true,
                                    wordWrapWidth: 800,
                                },
                            },
                            {
                                "id": "right_which_text",
                                "name": "right_which_tex",
                                "type": "Text",
                                "x":248,
                                "y": 291,
                                "width": 500,
                                "visible": true,
                                "text": "buyInText1",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'impact',
                                    fontSize: 30,
                                    fontStyle: 'bold',
                                    fill: ['#fd9d08', '#f0e700'],
                                    align: 'center',
                                    wordWrap: true,
                                    wordWrapWidth: 500,
                                },
                            },
                            {
                                "id": "right_X_text",
                                "name": "right_X_text",
                                "type": "BitMapText",
                                "x": 254,
                                "y": 380,
                                "width": 500,
                                "text": "X1",
                                visible: true,
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    font: '80px otal_win_value-export',
                                },
                            },
                            {
                                "id": "right_bottom_text",
                                "name": "right_bottom_text",
                                "type": "Text",
                                "x": 248,
                                "y": 473,
                                "width": 500,
                                "visible": true,
                                "text": "buyInText2",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'impact',
                                    fontSize: 30,
                                    fontStyle: 'bold',
                                    fill: ['#fd9d08', '#f0e700'],
                                    align: 'center',
                                    wordWrap: true,
                                    wordWrapWidth: 500,
                                },
                            },

                            {
                                "id": "right_buy_text",
                                "name": "right_buy_text",
                                "type": "BitMapText",
                                "x": 260,
                                "y": 155,
                                "width": 350,
                                "text": "888.88",
                                visible: true,
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    font: '80px otal_win_value-export',
                                },
                            },
                        ]
                    },
                    {
                        "id": "leftBuyContainer",
                        "name": "leftBuyContainer",
                        "type": "Container",
                        "x": 446,
                        "y": 190,
                        "visible": false,
                        "filterTypes": [],
                        child: [
                            {
                                "name": "buy_bonus_base_left",
                                "image": "buy_bonus_base.png",
                                "type": objectTypes.Sprite,
                                "layout": false,
                                "uimode": "desktop",
                                "visible": true,
                                "width": 515,
                                "height": 714,
                                "x": 0,
                                "y": 0,
                            },
                            {
                                "id": "buyBtn_left",
                                "name": "buyBtn_left",
                                "type": objectTypes.Sprite,
                                "buttonMode": true,
                                //"uimode": "desktop",
                                "interactive": false,
                                "layout": true,
                                "x": 240,
                                "y": 568,
                                "width": 180,
                                "height": 93,
                                "text": "BuyBtnText",
                                "textStyle": {
                                    fontFamily: 'impact',
                                    fontSize: 30,
                                    fontStyle: 'bold',
                                    fill: ['#fd9d08', '#f0e700'],
                                },
                                "anchor": [0.5, 0.5],
                                "visible": true,
                                "buttonState": {
                                    up: 'buy_up.png',
                                    out: 'buy_up.png',
                                    down: 'buy_down.png',
                                    disable: 'buy_disable.png',
                                    enable: 'buy_up.png',
                                    hover: 'buy_over.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                           
                            {
                                "id": "left_15_text",
                                "name": "left_15_text",
                                "type": "Text",
                                "x": 245,
                                "y": 226,
                                "width": 800,
                                "visible": true,
                                "text": "buyInNumber1",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'Oswald-SemiBold',
                                    fontSize: 40,
                                    fontStyle: 'bold',
                                    fill: ['#a47f00', '#fdf972'],
                                    align: 'center',
                                    wordWrap: true,
                                    wordWrapWidth: 800,
                                },
                            },
                            {
                                "id": "left_which_text",
                                "name": "left_which_text",
                                "type": "Text",
                                "x": 248,
                                "y": 291,
                                "width": 500,
                                "visible": true,
                                "text": "buyInText1",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'impact',
                                    fontSize: 30,
                                    fontStyle: 'bold',
                                    fill: ['#fd9d08', '#f0e700'],
                                    align: 'center',
                                    wordWrap: true,
                                    wordWrapWidth: 500,
                                },
                            },
                            {
                                "id": "left_X_text",
                                "name": "left_X_text",
                                "type": "BitMapText",
                                "x": 254,
                                "y": 380,
                                "width": 500,
                                "text": "X1",
                                visible: true,
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    font: '80px otal_win_value-export',
                                },
                            },
                            {
                                "id": "left_bottom_text",
                                "name": "left_bottom_text",
                                "type": "Text",
                                "x": 248,
                                "y": 473,
                                "width": 500,
                                "visible": true,
                                "text": "buyInText2",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'impact',
                                    fontSize: 30,
                                    fontStyle: 'bold',
                                    fill: ['#fd9d08', '#f0e700'],
                                    align: 'center',
                                    wordWrap: true,
                                    wordWrapWidth: 500,
                                },
                            },

                            {
                                "id": "left_buy_text",
                                "name": "left_buy_text",
                                "type": "BitMapText",
                                "x": 260,
                                "y": 155,
                                "width": 350,
                                "text": "888.88",
                                visible: true,
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    font: '80px otal_win_value-export',
                                },
                            },
                        ]
                    },




                    {
                        "id": "Button_7",
                        "name": "bonusBuyBtn_desktop",
                        "type": objectTypes.Sprite,
                        "buttonMode": true,
                        "uimode": "desktop",
                        "interactive": true,
                        "layout": false,
                        "x": 1780,
                        "y": 255,
                        "width": 221,
                        "height": 102,
                        "text": "buy-a-feature-button-text",
                        "anchor": [0.5, 0.5],
                        "textStyle": {
                            fontFamily: 'Impact',
                            fontSize: 32,
                            fontStyle: 'bold',
                            fill: ['#f0e700', '#fd9d08'],
                            wordWrap: true,
                            wordWrapWidth: 400,
                            stroke: '#ca0606',
                            strokeThickness: 4,
                            dropShadow: true,
                            dropShadowColor: '#000000',
                            dropShadowAngle: Math.PI / 2,
                            dropShadowDistance: 6,

                        },
                        "visible": true,
                        "buttonState": {
                            up: 'bonus_buy_up.png',
                            out: 'bonus_buy_up.png',
                            down: 'bonus_buy_down.png',
                            disable: 'bonus_buy_disable.png',
                            enable: 'bonus_buy_up.png',
                            hover: 'bonus_buy_over.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },

                    {
                        "id": "Button_7",
                        "name": "bonusBuyBtn_mobile",
                        "type": objectTypes.Sprite,
                        "buttonMode": true,
                        "uimode": "mobile",
                        "interactive": true,
                        "layout": true,
                        "x": 1780,
                        "y": 255,
                        "width": 221,
                        "height": 102,
                        "text": "buy-a-feature-button-text",
                        "anchor": [0.5, 0.5],
                        "textStyle": {
                            fontFamily: 'Impact',
                            fontSize: 46,
                            fontStyle: 'bold',
                            fill: ['#f0e700', '#fd9d08'],
                            wordWrap: true,
                            wordWrapWidth: 200,
                            stroke: '#ca0606',
                            strokeThickness: 4,
                            dropShadow: true,
                            dropShadowColor: '#000000',
                            dropShadowAngle: Math.PI / 2,
                            dropShadowDistance: 6,

                        },
                        "visible": true,
                        "buttonState": {
                            up: 'bonus_buy_up.png',
                            out: 'bonus_buy_up.png',
                            down: 'bonus_buy_down.png',
                            disable: 'bonus_buy_disable.png',
                            enable: 'bonus_buy_up.png',
                            hover: 'bonus_buy_over.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
                    {
                        "id": "buyFeature_closeButton",
                        "name": "buyFeature_closeButton",
                        "type": objectTypes.Sprite,
                        "interactive": true,
                        //"layout": true,
                        "x": 1837,
                        "y": 49,
                        "height": 40,
                        "width": 40,
                        "text": "",
                        "visible": true,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'paytable_closed_normal.png',
                            out: 'paytable_closed_normal.png',
                            down: 'paytable_closed_normal.png',
                            disable: 'paytable_closed_normal.png',
                            enable: 'paytable_closed_normal.png',
                            hover: 'paytable_closed_over.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
                ]
            },

        ]
    }

};

export const BuyFeatureConfigurationContext = React.createContext(
    {}
);